<template>
  <div class="p-l-5 m-b-10">
    <div class="m-b-2 m-t-10">
      <strong>{{ columnDisplayName }}</strong>
    </div>

    <table class="table_beauty condensed-alternate routing-plan-args">
      <thead>
        <tr class="bg-transparent">
          <th>{{ $t('RTB_REROUTE_NAME') }}</th>
          <th v-if="columnName.toLowerCase() === 'ineligibletargets'">
            {{ $t('RTB_REROUTE_REASON') }}
          </th>
          <th class="text-right rtb-reroute-args__bids">
            {{ $t('RTB_REROUTE_BID') }}
          </th>
          <th class="text-right rtb-reroute-args__bids">
            {{ $t('RTB_REROUTE_MIN_TARGET_BID') }}
          </th>
          <th class="text-right rtb-reroute-args__bids">
            {{ $t('RTB_REROUTE_TARGET_BID') }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(target, index) in parsedRerouteEligibilityDetail"
          :key="index"
          class="bg-transparent"
          :class="[target.reasons && target.reasons.length > 1 ? 'vertical-top' : '']"
        >
          <td>
            <a
              v-tooltip.top.hover="
                $t('RTB_REROUTE_VIEW_TARGET')
              "
              :href="target.url"
              target="_blank"
              class="table-ellipsis__name linked-name"
            >{{ target.name }}</a>
          </td>

          <td
            v-if="columnName.toLowerCase() === 'ineligibletargets'"
          >
            <div
              v-for="(reason, i) in target.reasons"
              :key="i"
            >
              {{ reason ? reason : $t('RTB_REROUTE_REASON_TEXT') }}
            </div>
          </td>
          <td class="text-right">
            ${{ target.bid }}
          </td>
          <td class="text-right">
            ${{ target.minimumMargin }}
          </td>
          <td class="text-right">
            ${{ target.targetBid }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import messages from '../../../locales';
import sharedMessages from '@/core/locales';


export default {
  name: 'RTBRerouteEligibilitySummary',
  props: {
    targets: {
      type: String,
      default: '',
    },
    columnName: {
      type: String,
      default: '',
    },
    columnDisplayName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      parsedRerouteEligibilityDetail: [],
    };
  },
  computed: {
    multipleReasons: function() {
      return this.content['cravings'] ? 'fa-checkbox-marked' : 'fa-checkbox-blank-outline';
    }
  },
  watch: {
    targets: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.parsedRerouteEligibilityDetail = this.parseRerouteEligibilityDetail(
            this.getTargetsFromString(newValue)
          );
        }
      },
    },
  },
  methods: {
    getTargetsFromString(value) {
      const splitTargetsRegex = /(\[\d+,\s?\d+\],)/gm;
      const splitTargets = value.split('\n');
      const targets = [];

      for (let j = 0; j < splitTargets.length; j++) {
        if (splitTargets[j]) {
          const splitString = splitTargets[j].split(splitTargetsRegex);
          for (let i = 0; i < splitString.length; i += 2) {
            if (splitString[i]) {
              targets.push(`${splitString[i]}${splitString[i + 1] ? splitString[i + 1] : ''}`.replace(/,$/, ''));
            }
          }
        }
      }
      return targets;
    },
    parseRerouteEligibilityDetail(targets) {
      const splitDecimalAndReasonArrayRegex = /(\[\d*\.?\d*,\s?\d*\.?\d*,\s?\d*\.?\d*,\s?.*])/;
      const splitTargetNameRegex = /(\[.+\])/;
      const splitTargetIdRegex = /([^[].+[^\]])/;
      const splitReasonsRegex = /(^(?:[^,]*,){3}(.*))/;

      if (targets?.length) {
        return targets
          .map((target) => {
            target.replace('\n', '');
            const splitMarginArrayString = target.split(splitDecimalAndReasonArrayRegex);
            const splitMarginArray = splitMarginArrayString[1]?.replace('[', '').replace(']','').split(',', 3);
            const splitReasons = splitMarginArrayString[1].split(splitReasonsRegex)[2]?.replace('[', '').replace(']','').split(' - ');

            const targetIdAndName = splitMarginArrayString[0]?.split(splitTargetNameRegex); 
            const targetIdString = targetIdAndName[1]?.split(splitTargetIdRegex);
            const url = targetIdString[1].substring(0, 2) === 'PI' ? `#/dashboard/ringtreetarget/edit/${targetIdString[1]}` : `#/dashboard/target/edit/${targetIdString[1]}`;

            return {
              name: targetIdAndName[0],
              bid: splitMarginArray[0],
              minimumMargin: splitMarginArray[1],
              targetBid: splitMarginArray[2],
              url,
              reasons: splitReasons
            };
          });
      }

      return [];
    }
  },
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  }
};
</script>

<style lang="scss" scoped>
.routing-plan-args__priority,
.routing-plan-args__weight {
  width: 45px;
}
</style>